import React from 'react';

import CooperationMaterialForm from './CooperationMaterialForm';

const CooperationIssue = () => {
  return <CooperationMaterialForm mode="issue" />;
};

export default CooperationIssue;
